<style src="./../../assets/styles.css"></style>
<style src="./../../assets/responsive.css"></style>
<template>
    <footer class="footer" v-if="footer">
        <div class="container">
            <div class="row justify-center">
                <div class="col-xs-12 col-lg-2 footer__info">
                    <div class="footer__logo">
                        <img :src="footer.logo" alt="" class="footer__logo-image">
                    </div>
<!--
                    <div class="footer__text-container">
                        <p class="footer__text">
                            {{ footer.text }}
                        </p>
                    </div>
                    <div class="footer__social">
                        <a :href="footer.facebook" class="footer__social-icon" v-if="footer.facebook">
                            <font-awesome-icon :icon="[ 'fab', 'facebook-f' ]" size="lg"></font-awesome-icon>
                        </a>
                        <a :href="footer.youtube" class="footer__social-icon" v-if="footer.youtube">
                            <font-awesome-icon :icon="[ 'fab', 'youtube' ]" size="lg"></font-awesome-icon>
                        </a>
                        <a :href="footer.instagram" class="footer__social-icon" v-if="footer.instagram">
                            <font-awesome-icon :icon="[ 'fab', 'instagram' ]" size="lg"></font-awesome-icon>
                        </a>
                        <a :href="footer.twitter" class="footer__social-icon" v-if="footer.twitter">
                            <font-awesome-icon :icon="[ 'fab', 'twitter' ]" size="lg"></font-awesome-icon>
                        </a>
                        <a :href="footer.linkedin" class="footer__social-icon" v-if="footer.linkedin">
                            <font-awesome-icon :icon="[ 'fab', 'linkedin-in' ]" size="lg"></font-awesome-icon>
                        </a>
                    </div>
-->
                </div>
                <div class="col-xs-12 col-sm-8 footer__seo">
                    <div class="row">
                        <div class="col-xs-12 col-lg-3">
                            <!-- <h5 class="footer__header">{{ footer['seo-link-1'] }}</h5> -->
                            <ul class="footer__list">
                                <li class="footer__item" v-for="(item, index) in footer.menu[0]" :key="index">
                                    <a href="#" class="footer__link" @click.prevent="goToPage(item.url)">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xs-12 col-lg-3">
                            <!-- <h5 class="footer__header">{{ footer['seo-link-2'] }}</h5> -->
                            <ul class="footer__list">
                                <li class="footer__item" v-for="(item, index) in footer.menu[1]" :key="index">
                                    <a href="#" class="footer__link" @click.prevent="goToPage(item.url)">{{ item.name }}</a>
                                </li>
                                <li class="footer__item" v-if="footer.facebook">
                                    <a :href="footer.facebook" class="footer__link social-media__link" target="_blank">Facebook</a>
                                </li>
                            </ul>
                        </div>
<!--
                        <div class="col-xs-12 col-sm-4">
                            <h5 class="footer__header">{{ footer['seo-link-3'] }}</h5>
                            <ul class="footer__list">
                                <li class="footer__item" v-for="(item, index) in footer.menu[2]" :key="index">
                                    <a :href="item.url" class="footer__link">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
-->
                        <div class="col-12 col-lg-6">
                            <form class="newsletter">
                                <p class="newsletter__title">Newsletter</p>
                                <div class="newsletter__box">
                                    <input type="email" class="form-control newsletter__email" placeholder="Adresa de email" v-model="email">
                                    <button class="btn btn-primary call-to__button newsletter__button" :disabled="checkMail" @click.prevent="sendNewsletter">Aboneaza-ma</button>
                                </div>
                                <div class="form-check mt-2">
                                    <input class="form-check-input" type="checkbox" id="newsletter" v-model="promotion">
                                    <label class="form-check-label" for="newsletter">Sunt de acord cu <router-link to="/termeni-si-conditii" class="terms"> Termenii si Conditiile</router-link></label>
                                </div>
                                <div class="success text-success my-1 text-center" v-if="successMessage !== ''">
                                    <p class="success__text"> {{ successMessage }} </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-lg-2 footer__bottom">
                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
<!--
                            <p class="footer__text">
                                {{ footer.copywrite }}
                            </p>
-->
                        </div>
                        <div class="col-xs-12 col-sm-7">
<!--
                            <ul class="footer__list footer__list--second">
                                <li class="footer__list-item" v-for="(item, index) in footer.menu[3]" :key="index">
                                    <a :href="item.url" class="footer__link">{{ item.name }}</a>
                                </li>
                            </ul>
-->
                        </div>
                        <div class="col-xs-12 col-sm-12 footer__wbm-container">
                            <a href="https://www.webmagnat.ro" target="_blank" class="footer__wbm-link"><img src="./../../assets/img/webmagnat.png" alt="" class="footer__wbm"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        data () {
            return {
                footer: {
                    menu: {}
                },
                email: '',
                promotion: false,
                successMessage: ''
            }
        },
        computed: {
            checkMail () {
                if(!(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email)) || this.promotion === false) return true
                else return false
            }  
        },
        created () {
            this.getFooter()
        },
        methods: {
            getFooter () {
                this.$http.get('/footer/1')
                .then(response => {
                    this.footer = response.data
                    console.log(this.footer)
                    this.footer.menu.forEach(el => el.sort((a, b) => a.order - b.order))
                })
                .catch(e => {
                    console.log(e)
                    this.$router.push('/404')
                })
            },
            goToPage (slug) {
                this.$router.push(`${slug}`)
            },
            sendNewsletter () {
                this.$http.post(`consent`, {
                    email: this.email,
                    form_type: 'newsletter',
                    comercial_offer: 0,
                    promotions: this.promotion
                }).then(response => {
                    if (response.status == 201) {
                        this.successMessage = 'V-ati abonat cu succes la newsletter!'
                        setTimeout(() => {this.successMessage = ''}, 3000)
                    }
                    this.resetForm()
                    
                }).catch(e => console.log(e))
            },
            resetForm () {
                this.email = '',
                this.promotion = false
                let form = document.querySelector('.newsletter')
                form.reset()
            }
        }
    }
</script>